import { Button, Collapse, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { toJalaliFullDate } from "../../middleware/middleware";

const HistoryItem = ({ history }) => {
  const [isLongText, setIsLongText] = useState(false);
  const [showFullText, setShowFullText] = useState(false);

  useEffect(() => {
    if (history.description && history.description.length > 100) {
      setIsLongText(true);
      setShowFullText(false);
    } else {
      setIsLongText(false);
    }
  }, [history.description]);

  return (
    <Grid
      item
      xs={12}
      container
      spacing={1}
      sx={{ borderBottom: "1px solid", borderColor: "divider", mb: 2, pb: 1 }}
    >
      <Grid item xs={12}>
        <Typography variant="body1" fontWeight={600}>
          {history.title}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body2" textAlign={"justify"}>
          {isLongText ? (
            <>
              <Collapse in={!showFullText}>
                {history.description.substr(0, 100) + "..."}
              </Collapse>

              <Collapse in={!!showFullText}>{history.description}</Collapse>

              <Button
                variant="text"
                size="small"
                onClick={() => {
                  setShowFullText((old) => !old);
                }}
              >
                {showFullText ? "مشاهده کمتر" : "مشاهده بیشتر"}
              </Button>
            </>
          ) : (
            history.description
          )}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography
          variant="body2"
          color={"text.secondary"}
          textAlign={"right"}
        >
          {toJalaliFullDate(history.updateOn)}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default HistoryItem;
